import { Injectable, inject } from '@angular/core';
import { DevicesService, InstalledApplication } from '@era/locations-sdk';
import { safeMap } from '@era/stores';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { mergeMap } from 'rxjs';
import {
  InstalledApplicationsApiActions,
  InstalledApplicationsResolverActions,
} from './device-installed-applications.actions';

@Injectable()
export class DeviceInstalledApplicationsStatusEffects {
  private readonly devicesService = inject(DevicesService);
  private readonly actions$ = inject(Actions);

  deviceInstalledApplicationsRequestedEffect$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(InstalledApplicationsResolverActions.installedApplicationsRequested),
      mergeMap(({ brandId, locationId }) =>
        safeMap(
          this.devicesService.getInstalledApplicationsByLocation({ brandId, locationId }),
          (installedApplications: InstalledApplication[]) =>
            InstalledApplicationsApiActions.installedApplicationsLoaded({ installedApplications }),
          (error) => InstalledApplicationsApiActions.installedApplicationsLoadedError({ error })
        )
      )
    );
  });
}
